module.exports = __webpack_public_path__ + "static/media/СЗФО_95.217e8e99.png";